import { isDisplayLive, type DisplayScheduleWindow } from '../../lib/displaySchedule';

/**
 * 홈 팝업 목록의 범위(탭) 선택을 순수 함수로 분리한 것 — 배너 목록(`bannerListView`)과 같은 얼개다.
 *
 * 컴포넌트에 인라인으로 두면 "노출 중" 의 정의가 화면 안에서 굳어, 스토어프론트 조건
 * (활성 AND 예약 윈도우 안)과 어긋나도 테스트로 잡히지 않는다.
 */

/** 목록 범위 탭. */
export type PopupScope =
  /** 지금 실제로 스토어프론트에 노출 중인 것만(활성 + 예약 윈도우 안). */
  | 'live'
  /** 비활성·기간 종료·노출 예정까지 전부. */
  | 'all';

export interface PopupListRow extends DisplayScheduleWindow {
  isActive: boolean;
}

/**
 * 범위 필터를 적용한 목록을 돌려준다(입력 배열은 변경하지 않는다).
 *
 * 정렬은 건드리지 않는다 — BE 가 `sortOrder` 순으로 내려주고, 그 순서가 곧 스토어프론트의
 * 노출 순서다. 목록에서 임의로 다시 정렬하면 화면 순서와 실제 노출 순서가 달라진다.
 */
export const selectPopupRows = <T extends PopupListRow>(
  rows: ReadonlyArray<T>,
  scope: PopupScope,
  now: number = Date.now(),
): T[] => (scope === 'live' ? rows.filter((r) => isDisplayLive(r, now)) : rows.slice());

/** '노출 중' 탭의 건수. 탭 라벨에 붙는 숫자라 전체 목록 기준으로 세야 한다. */
export const countLivePopups = <T extends PopupListRow>(
  rows: ReadonlyArray<T>,
  now: number = Date.now(),
): number => rows.reduce((n, r) => (isDisplayLive(r, now) ? n + 1 : n), 0);
